/* eslint-disable array-callback-return */
import React from 'react';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import globals from '../../../globals/communityGlobals';
import { mapActivities } from '../../../actions/areas/shared/mappingHelper';
import { mapBundledActivities } from './mappingHelper';
import { ragStatusWithDesc, Band } from '../../../enums';
import _ from '../../../utils/lodash';

const locale = globals.getArea('treatments');
export default function BundleVisitActivities({ items, treatmentInstance, overiddenDuration, errorMsg, isBundled }) {
  const distinctActivities = () => {
    const allActivities = isBundled ? mapBundledActivities(items) : mapActivities(items);
    const activities = [];
    allActivities.map(activity => {
      const findActivity = activities.find(x => x.id === activity.id);
      if (!findActivity) activities.push(activity);
    });

    return activities;
  };

  const activities = distinctActivities();

  const distinctTreatmentIds = () => {
    const activityList = [];
    activities.flat().map(activity => {
      const findActivity = activityList.find(x => x.treatmentId === activity.treatmentId);
      if (!findActivity) activityList.push(activity);
    });

    return activityList.map(x => x.treatmentId);
  };

  const treatmentIds = distinctTreatmentIds();

  const getTotalDuration = bundleActivities => {
    return bundleActivities.reduce((sum, activity) => sum + activity.duration, 0);
  };

  const getHighestRagByTreatment = treatmentId => {
    const ragStatuses = items
      .filter(instance => instance.treatmentId === treatmentId)
      .map(instance => instance.ragStatus);
    const ragStatusesWithDesc = _.filter(ragStatusWithDesc, r => {
      return ragStatuses.find(x => x.id === r.id);
    });
    const maxRagStatus = ragStatusesWithDesc.reduce((max, x) => (max.sortingOrder > x.sortingOrder ? max : x), 0);

    return ragStatuses.find(x => x.id === maxRagStatus.id).name;
  };

  const getHighestBandByTreatment = treatmentId => {
    const bandsIds = items.filter(instance => instance.treatmentId === treatmentId).map(instance => instance.band.id);
    const maxBandId = Math.max(...bandsIds);

    const bandsWithDesc = _.filter(Band, b => {
      return bandsIds.find(x => x === b.id);
    });

    return bandsWithDesc.find(x => x.id === maxBandId).Name;
  };

  const renderBundleActivitiesRows = (activitiesName, activitiesByTreatment, treatmentId) => {
    return (
      <tbody>
        <tr>
          <td>{activitiesName}</td>
          <td>{getTotalDuration(activitiesByTreatment)}</td>
          <td>{getHighestRagByTreatment(treatmentId)}</td>
          <td>{getHighestBandByTreatment(treatmentId)}</td>
        </tr>
      </tbody>
    );
  };

  const mapActivitiesByTreatment = treatmentId => {
    const activitiesByTreatment = activities.flat().filter(x => x.treatmentId === treatmentId);
    const activitiesName = activitiesByTreatment.map(x => x.name).join(', ');

    if (!isBundled) {
      return (
        <tbody>
          <tr>
            <td>{activitiesName}</td>
            <td>{getTotalDuration(activitiesByTreatment)}</td>
          </tr>
        </tbody>
      );
    }

    return renderBundleActivitiesRows(activitiesName, activitiesByTreatment, treatmentId);
  };

  const totalDuration = () => {
    const totalActivitiesDuration = getTotalDuration(activities);

    if (overiddenDuration !== null) {
      errorMsg('');
      return totalActivitiesDuration;
    }

    if (totalActivitiesDuration <= 0 || totalActivitiesDuration > 1440) {
      errorMsg(locale.getMsg('totalDurationErrorMsg'));
    }

    return totalActivitiesDuration;
  };

  const renderActivitiesColumns = () => {
    if (!isBundled) {
      return (
        <thead>
          <tr>
            <th>{locale.getMsg('visit')}</th>
            <th>{locale.getMsg('duration')}</th>
          </tr>
        </thead>
      );
    }

    return (
      <thead>
        <tr>
          <th>{locale.getMsg('visit')}</th>
          <th>{locale.getMsg('duration')}</th>
          <th>{locale.getMsg('ragStatus')}</th>
          <th>{locale.getMsg('requiredGrade')}</th>
        </tr>
      </thead>
    );
  };

  const overriddenDuration = () => {
    return overiddenDuration || 0;
  };

  return (
    <div>
      <table className="table-visits">
        {renderActivitiesColumns()}
        {treatmentIds.map(mapActivitiesByTreatment)}
        <tfoot>
          <tr>
            <th id="total">{locale.getMsg('totalDuration')}</th>
            <td>
              <strong>{totalDuration()}</strong>
            </td>
          </tr>
          <tr>
            <th id="overriddenDuration">{locale.getMsg('overriddenDuration')}</th>
            <td>
              <strong>{overriddenDuration()}</strong>
            </td>
          </tr>
        </tfoot>
      </table>
      <div>
        {treatmentInstance && treatmentInstance.notes && treatmentInstance.notes !== '' && (
          <div className="clinician-info-box">
            <Typography variant="h6" gutterBottom>
              Treatment Instance Notes
            </Typography>
            <Box component="div" overflow="auto" maxHeight={150} className="treatment-description">
              {treatmentInstance.notes}
            </Box>
          </div>
        )}
      </div>
    </div>
  );
}
